"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.generateShowHourMinuteSecond = generateShowHourMinuteSecond;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));
var _react = _interopRequireWildcard(require("react"));
var _moment = require("moment");
var _classnames = _interopRequireDefault(require("classnames"));
var _LocaleReceiver = _interopRequireDefault(require("../locale-provider/LocaleReceiver"));
var _en_US = _interopRequireDefault(require("./locale/en_US"));
var _timePicker = _interopRequireDefault(require("../rc-components/time-picker"));
var _ConfigContext = _interopRequireDefault(require("../config-provider/ConfigContext"));
function generateShowHourMinuteSecond(format) {
  // Ref: http://momentjs.com/docs/#/parsing/string-format/
  return {
    showHour: format.indexOf('H') > -1 || format.indexOf('h') > -1 || format.indexOf('k') > -1,
    showMinute: format.indexOf('m') > -1,
    showSecond: format.indexOf('s') > -1
  };
}
var TimePicker = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(TimePicker, _Component);
  var _super = (0, _createSuper2["default"])(TimePicker);
  function TimePicker(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TimePicker);
    _this = _super.call(this, props);
    _this.handleChange = function (value) {
      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        _this$props$format = _this$props.format,
        format = _this$props$format === void 0 ? 'HH:mm:ss' : _this$props$format;
      if (onChange) {
        onChange(value, value && value.format(format) || '');
      }
    };
    _this.handleOpenClose = function (_ref) {
      var open = _ref.open;
      var onOpenChange = _this.props.onOpenChange;
      if (onOpenChange) {
        onOpenChange(open);
      }
    };
    _this.saveTimePicker = function (timePickerRef) {
      _this.timePickerRef = timePickerRef;
    };
    _this.renderTimePicker = function (locale) {
      var props = (0, _objectSpread2["default"])({}, _this.props);
      var value = _this.state.value;
      var getPrefixCls = _this.context.getPrefixCls;
      delete props.defaultValue;
      var prefixCls = getPrefixCls('time-picker', props.prefixCls);
      var format = _this.getDefaultFormat();
      var className = (0, _classnames["default"])(props.className, (0, _defineProperty2["default"])({}, "".concat(prefixCls, "-").concat(props.size), !!props.size));
      var addon = function addon(panel) {
        return props.addon ? /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(prefixCls, "-panel-addon")
        }, props.addon(panel)) : null;
      };
      return /*#__PURE__*/_react["default"].createElement(_timePicker["default"], (0, _extends2["default"])({}, generateShowHourMinuteSecond(format), props, {
        prefixCls: prefixCls,
        ref: _this.saveTimePicker,
        format: format,
        className: className,
        value: value,
        placeholder: props.placeholder === undefined ? locale.placeholder : props.placeholder,
        onChange: _this.handleChange,
        onOpen: _this.handleOpenClose,
        onClose: _this.handleOpenClose,
        addon: addon
      }));
    };
    var value = props.value || props.defaultValue;
    if (value && !(0, _moment.isMoment)(value)) {
      throw new Error('The value/defaultValue of TimePicker must be a moment object');
    }
    _this.state = {
      value: value
    };
    return _this;
  }
  (0, _createClass2["default"])(TimePicker, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('value' in nextProps) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.timePickerRef.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.timePickerRef.blur();
    }
  }, {
    key: "getDefaultFormat",
    value: function getDefaultFormat() {
      var _this$props2 = this.props,
        format = _this$props2.format,
        use12Hours = _this$props2.use12Hours;
      if (format) {
        return format;
      }
      if (use12Hours) {
        return 'h:mm:ss a';
      }
      return 'HH:mm:ss';
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_LocaleReceiver["default"], {
        componentName: "TimePicker",
        defaultLocale: _en_US["default"]
      }, this.renderTimePicker);
    }
  }], [{
    key: "contextType",
    get: function get() {
      return _ConfigContext["default"];
    }
  }]);
  return TimePicker;
}(_react.Component);
exports["default"] = TimePicker;
TimePicker.displayName = 'TimePicker';
TimePicker.defaultProps = {
  align: {
    offset: [0, -2]
  },
  disabled: false,
  disabledHours: undefined,
  disabledMinutes: undefined,
  disabledSeconds: undefined,
  hideDisabledOptions: false,
  placement: 'bottomLeft',
  transitionName: 'slide-up',
  focusOnOpen: true
};